import { render, staticRenderFns } from "./JournalismItem.vue?vue&type=template&id=0bd97c6a&scoped=true"
import script from "./JournalismItem.vue?vue&type=script&lang=js"
export * from "./JournalismItem.vue?vue&type=script&lang=js"
import style0 from "./JournalismItem.vue?vue&type=style&index=0&id=0bd97c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd97c6a",
  null
  
)

export default component.exports